import { render } from "./VideoViewer.vue?vue&type=template&id=3e556ac4&scoped=true"
import script from "./VideoViewer.vue?vue&type=script&lang=js"
export * from "./VideoViewer.vue?vue&type=script&lang=js"

import "./VideoViewer.vue?vue&type=style&index=0&id=3e556ac4&scoped=true&lang=css"
import "./VideoViewer.vue?vue&type=style&index=1&id=3e556ac4&lang=css"

import exportComponent from "../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-3e556ac4"]])

export default __exports__